import { VueModule } from '@Foundation';
import GenericBanner from './code/Scripts/components/generic-banner';
export default VueModule({
    components: {
        GenericBanner

    }
});